import styled from "styled-components";

export const PgHeader = styled.div`
    background: linear-gradient(180deg, #363156, #544176);
    height: 160px;
`;

export const PgHeaderInr = styled.div`
    padding-top: 20px;
    width: 1200px;
    margin: 0 auto;
`;